module.exports = require("punycode");


//////////////////
// WEBPACK FOOTER
// external "punycode"
// module id = punycode
// module chunks = 5